export default __webpack_public_path__ + "static/media/C0005.fb717d82.png";